import styled from "styled-components";
import { useMemo, useState } from "react";
import Skeleton from "../../components/ui/Skeleton";
import { CourseCardLoader } from "../../components/cards/CourseCard";
import Tag from "../../sharedUI/Tag";
import Input from "../../sharedUI/Input";
import { useCache } from "../../caching/caches";
import { breakPoints } from "../../utils/config";
import DocumentEntryCard from "../../components/cards/DocumentEntryCard";

const StyledDocumentsPage = styled.div`
  .top-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .tags-container {
      display: flex;
      flex-wrap: wrap;
      gap: 0.5rem;
      margin-bottom: 1rem;
    }
  }
  .cards-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }
  padding-bottom: 20rem;
  ${breakPoints.mobile} {
    .cards-container {
      grid-template-columns: 1fr;
    }
  }
`;

const DocumentsPage = () => {
  const { loading, state: entries } = useCache("documents");
  const [selectedTags, setSelectedTags] = useState([]);
  const [searchString, setSearchString] = useState("");

  const toggleTag = (tag) => {
    const updated = [...selectedTags];
    const index = selectedTags.indexOf(tag);
    if (index === -1) updated.push(tag);
    else updated.splice(index, 1);
    setSelectedTags(updated);
  };

  const filtered = useMemo(() => {
    let filtered = [...entries];
    if (selectedTags.length)
      filtered = filtered.filter((entry) =>
        selectedTags.every((tag) => entry.tags.includes(tag))
      );
    if (searchString)
      filtered = filtered.filter((entry) => {
        const searchLc = searchString.toLowerCase();
        const titleLc = entry.title.toLowerCase();
        return titleLc.includes(searchLc);
      });
    return filtered;
  }, [selectedTags, searchString, entries]);

  const allTags = useMemo(() => {
    return [...new Set(filtered.flatMap((e) => e.tags))];
  }, [filtered]);

  return (
    <StyledDocumentsPage className="content">
      <h1 className="mtop2">Information</h1>
      <div className="top-container">
        <div className="tags-container">
          {allTags.map((tag, i) => (
            <Tag
              key={`tag_${tag}_${i}`}
              tagName={tag}
              selected={selectedTags.includes(tag)}
              select={() => toggleTag(tag)}
            />
          ))}
        </div>
        <div className="buttons-container">
          <Input
            type="search"
            placeholder="Sök information"
            onChange={(e) => setSearchString(e.target.value)}
            value={searchString}
          />
        </div>
      </div>
      <div className="cards-container">
        {loading ? (
          <Skeleton
            identifier="guides"
            quantity={5}
            Component={CourseCardLoader}
          />
        ) : filtered.length ? (
          filtered.map((entry) => (
            <DocumentEntryCard key={entry._id} entry={entry} />
          ))
        ) : (
          <p>Ingen information hittades</p>
        )}
      </div>
    </StyledDocumentsPage>
  );
};

export default DocumentsPage;
